import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    'CategoryService',
    '$state',
    '$rootScope',
    'SharedService',
    '$stateParams',
    '$uibModal',
    'Pagination'
];

class CategoryController {
    constructor($scope, CategoryService, $state, $rootScope, SharedService, $stateParams, $uibModal, Pagination) {
        this.$state = $state;
        this.$scope = $scope;
        this.Pagination = Pagination;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CategoryService = CategoryService;
        this.SharedService = SharedService;
        this.loanding = false;
        this.pagerCategories = [];
        this.itemsPerPage = 12;
        this.loadingCategories = true;
        this.pageName = "PAG-19";
        this.postByCategory = [];
        this.categoryNameBlog = "";
        this.categoryDescription = "";
        this.company = "";

        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
            this.shCtrl.setTags(this.cmsData.seo);
        });
        this.$rootScope.$on('onChangeCompany', (event, arg) => {
          this.categoryPrincipal=arg;
          event.stopPropagation();
          this.SharedService.getCMSBanners(this.pageName, __env.adaptative ? 1:0,arg).then(response => {
            this.cmsData = response;
          });
        });
    }

    $onInit() {
        if (this.$stateParams.idCategory || this.$stateParams.categorySlug) {
            this.getSubcategories(this.$stateParams.idCategory, this.$stateParams.categorySlug);
        } else {
            try {

                this.pagerCategories = this.shCtrl.globalCategoriesMenu;


                this.pagination = this.Pagination.getNew(this.itemsPerPage);
                this.pagination.numPages = Math.ceil(this.pagerCategories.length / this.pagination.perPage);

                this.loadingCategories = false;
            }
            catch (e) {
            }
        }
        this.getCurrentCategory();

        // this.itemsPerPage = this.pagerCategories.length >= 12 ? 12:this.pagerCategories.length;

    }

    // /**
    //  Get categories
    //  @method getCategories
    //  @param url {String} URL to fetch the categories
    //  */
    // getCategories(url) {
    //   this.loadingCategories = true;
    //
    //   $http.get(url,
    //     {
    //       headers: { 'Cache-Control' : 'no-cache' }
    //     }
    //   )
    //     .success(function(data){
    //       this.loadingCategories = false;
    //
    //       this.pagerCategories = data;
    //
    //       this.pagination = Pagination.getNew(this.itemsPerPage);
    //       this.pagination.numPages = Math.ceil(this.pagerCategories.length/this.pagination.perPage);
    //     }).error(function(data){});
    // };

    /**
     Get subcategoriespostByCategory
     @method getSubcategories
     @param categoryId {String} URL to fetch the subcategories of a category
     @param categorySlug {String} URL to fetch the subcategories of a category
     */
    getSubcategories(categoryId, categorySlug) {

        let categoryIdSlug = categoryId || categorySlug;

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        this.loadingCategories = true;

        this.CategoryService.getSubcategories(categoryIdSlug, userId).then(response => {
            this.loadingCategories = false;
            if (response) {
                this.pagerCategories = response;
                this.pagination = this.Pagination.getNew(this.itemsPerPage);
                this.pagination.numPages = Math.ceil(this.pagerCategories.length / this.pagination.perPage);
            }
            else {
                this.$state.go('404');
            }
        }).catch(reason => {
            this.$state.go('404');
        });
    }

    /**
     Get current category
     @method getCurrentCategory
     */
    getCurrentCategory() {
        // currentCategory = response;
        this.CategoryService.getCurrentCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug).then(response => {


            this.currentCategory = response;
          this.shCtrl.setTags(this.currentCategory.seo);
            this.categoryName = response.title.toLowerCase();
            this.company = response.company;
            this.$rootScope.$emit('onChangeCompany',response.company);

            // if(this.shCtrl.ngAuthSettings.site.config.data.home.use_featured_by_category){

            //     this.$rootScope.$emit('onChangeCompany2',response);
            // }

            this.CategoryService.getPostByCategory(this.company).then(responsePostByCategory => {
                this.postByCategory = responsePostByCategory.posts;
            });

            this.CategoryService.getCategoryContent(this.company).then(responseCategoryContent => {
                this.categoryDescription = responseCategoryContent.descripcion;
            });

        }).catch(reason => {});
    }

    /**
     Set item per page on the pagination
     @method setPagination
     @param itemsPerPage {Integer} Items per page on the pager
     @example
     setpagination(8)
     */
    setPagination(itemsPerPage) {

        this.itemsPerPage = itemsPerPage;
        this.pagination = this.Pagination.getNew(this.itemsPerPage);
        this.pagination.numPages = Math.ceil(this.pagerCategories.length / this.pagination.perPage);
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

CategoryController.$inject = inject;

export default CategoryController;




// WEBPACK FOOTER //
// ./www/components/catalog/category/category.controller.js